import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Import components
import Nav from "../components/Nav";
import NavMobile from "../components/NavMobile";

// Import icon for gold scales of justice
import { FaBalanceScale } from "react-icons/fa";

const Header = () => {
  const [bg, setBg] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setBg(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`${
        bg ? "bg-white shadow-md py-4" : "bg-transparent py-6"
      } p-8 lg:px-0 w-full fixed top-0 z-10 transition-all duration-300`}
    >
      <div className="container mx-auto flex items-center justify-between">
        {/* Logo area */}
        <Link to="/" className="flex items-center space-x-2">
          <FaBalanceScale className="text-accent text-3xl" />
          <span className="font-primary font-extrabold text-2xl text-primary tracking-wide">
            Cire <span className="text-accent">Legal</span>
          </span>
        </Link>

        {/* Navigation (desktop) */}
        <Nav />

        {/* Navigation (mobile) */}
        <NavMobile />
      </div>
    </header>
  );
};

export default Header;
